
import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator";
import { Notify } from "quasar";
import FormValidator from "@/components/mixins/FormValidator";

@Component
export default class Actividades extends Mixins(FormValidator) {
  private comercios: Array<any> = [];
  private nombreWeb: any = "";
  private nombreCategoria: any = "";
  private logoCategoria: any = "";
  private mostrar: any = null;
  private currentPage = 1;
  private total: number = 0;

  @Watch("currentPage")
  private currentPageWatch(newValue: any) {
    if (newValue >= 0 && newValue <= Math.ceil(this.total / 8)) {
      // this.getInfoNoticia();
      this.getInfoComercios();
    }
  }

  private mounted() {
    if (
      this.$router.currentRoute.params.nombre &&
      this.$router.currentRoute.params.nombre != ""
    ) {
      this.nombreWeb = this.$router.currentRoute.params.nombre;
      this.getInfoComercios();
    }
  }

  private getInfoComercios() {
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.$axios
      .get(
        "/actividades/general?nombre_web=" +
          this.nombreWeb +
          "&pagina=" +
          this.currentPage
      )
      .then((res: any) => {
        this.total = res.data.total;
        this.comercios = res.data.actividades;
        if (this.comercios.length == 0) {
          this.mostrar = true;
        }
        let base = process.env.VUE_APP_BASE_URL;
        this.nombreCategoria = res.data.nombre_categoria;
        for (let i = 0; i < this.comercios.length; i++) {
          if (this.comercios[i].foto != null && this.comercios[i].foto) {
            this.comercios[i].foto = base + this.comercios[i].foto;
          } else {
            this.comercios[
              i
            ].foto = require("@/assets/logos/img-default-actividades.png");
          }
        }
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        console.log(err);
      });
  }

  private irActividad(idNoticia: any, nombreWeb: any) {
    if (
      this.$router.currentRoute.name == "PublicacionAct" &&
      this.$router.currentRoute.params.nombre == nombreWeb
    ) {
      this.$router.go(0);
    } else {
      this.$router
        .push({
          name: "PublicacionAct",
          params: { nombre: nombreWeb }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
}
